export default __webpack_public_path__ + "static/media/default_team_logo.2926b2f3.svg";